var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93882 7.89773L1.93997 7.89888L8.55744 7.89773V5.34029H5.04384C6.67507 3.63034 8.97024 2.56013 11.52 2.56013C16.4675 2.56013 20.4799 6.57139 20.4799 11.52H23.04C23.04 5.1575 17.8825 0 11.52 0C8.25638 0 5.31494 1.36358 3.22022 3.54509L3.21869 0.000383789H0.660095V6.61786C0.660095 7.32557 1.23264 7.89773 1.93882 7.89773Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1001 15.143V15.1418L14.4826 15.143V17.7005H17.995C16.3649 19.4105 14.0701 20.4803 11.52 20.4803C6.57254 20.4803 2.56013 16.4694 2.56013 11.5204H0C0 17.8829 5.1575 23.0404 11.52 23.0404C14.7824 23.0404 17.7251 21.6764 19.8198 19.4957V23.0404H22.3799V16.423C22.3799 15.7156 21.8074 15.143 21.1001 15.143Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.7e9f854b5e10712717753f7dbe0599db.svg";
export { ForwardRef as ReactComponent };